// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewsWrapper_wrapper__12frh","view":"ViewsWrapper_view__3tABT","view--hex":"ViewsWrapper_view--hex__3FZMd","view--text":"ViewsWrapper_view--text__2IqKL"};